module.exports = __webpack_public_path__ + "static/media/grandblue.8495271c.mp3";